<template>
  <div class="container-lg text-center">
    <div class="logo-size">
        <img src="../assets/gifs/Kilroy_closed_blanc.gif" alt="songattic logo" class="w-25" @mouseover="mouseOver" v-show="active"/>
        <img src="../assets/gifs/Kilroy_open_blanc.gif" alt="songattic logo" class="w-25" v-if="inactive"/>
    </div>
    <router-link to="/" class="text-dark"><h4>songattic.com</h4></router-link>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: true,
    inactive: false
  }), 
  methods: {
    mouseOver: function() {
      this.active = !this.active,
      this.inactive = !this.inactive
      setTimeout(() => {
        this.inactive = false
        this.active = true
      }, 4400)
    }
  }
}
</script>

<style>
.logo-size {
  height: 8em;
}

@media screen and (max-width:580px) {
  .logo-size {
    height: 6em;
  }
}

@media screen and (max-width:400px) {
  .logo-size {
    height: 4em;
  }
}
</style>